import React from "react"
import styled from "@emotion/styled"
const Container = styled.div`
  width: 10px;
`
const OpenWindowIcon = () => (
  <Container>
    <svg viewBox="0 0 20 17" version="1.1">
      <g stroke="none" fill="none">
        <g transform="translate(-331.000000, -12590.000000)" stroke="#000000">
          <g transform="translate(331.000000, 12590.000000)">
            <polygon points="5.00909091 12.4363464 18.3090909 12.4363464 18.3090909 0.863619091 5.00909091 0.863619091"></polygon>
            <polyline points="15.8909091 16.2366918 0.863636364 16.2366918 0.863636364 2.93669182"></polyline>
          </g>
        </g>
      </g>
    </svg>
  </Container>
)

export default OpenWindowIcon
